import { IconWriting } from "@tabler/icons";
import { formatTimeTaken } from "../common/commonfunc";
import { get_lottie_obj } from "../common/utils";
import AnalyticsTabs from "./AnalyticsTabs";

const TestAnalyticsSpeed = ({ number, other }) => {
    // console.log(formatTimeTaken(0));
    let num_suffix = null;
    let diff = 0;

    if (!!number) {
        let format = formatTimeTaken(number);
        num_suffix = format.split(" ")[1][0];

        number = parseFloat(format.split(" ")[0]).toFixed(1);

        other /= 1000;
        diff = (100 * ((other - number) / other)).toFixed(1);
    }
    return (
        <AnalyticsTabs
            title={"Speed"}
            // TitleIcon={IconWriting}
            AnimateIcon={get_lottie_obj({
                datakey: "write",
                width: 50,
                top: -10,
                left: "calc(100% - 35px)",
                position: "absolute",
            })}
            number={number}
            num_suffix={num_suffix}
            diff={diff}
            diffprefix=""
            diffsuffix="%"
            description="Compared with overall average speed of other aspirants"
            reverse={true}
        />
    );
};

export default TestAnalyticsSpeed;
